import React from 'react';
import TimesheetTable from './Component/Financial/Timesheet/TimesheetTable';

const TimesheetManagement = () => {

  return (
    <>
    <TimesheetTable/>
    </>
  )
};

export default TimesheetManagement;